import { Outlet, useLocation } from 'react-router-dom';
import { DashboardNavigation } from '../../components/common/DashboardNavigation';

export function DashboardLayout() {
  const location = useLocation();
  const hideNavbarOnPage = location.pathname === '/dashboard/select-role';

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="relative z-10 w-full">
        {!hideNavbarOnPage && <DashboardNavigation />}
        <main className={`flex-grow ${hideNavbarOnPage ? 'pt-0' : 'pt-14'}`}>
          <Outlet />
        </main>
      </div>
    </div>
  );

}

